module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_add-to-unscopables.js
// module id = OXMH
// module chunks = 0